/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6a54df72&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=6a54df72&scoped=true&lang=css"

import exportComponent from "D:\\work\\官网\\bfb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a54df72"]])

export default __exports__